import React, { useRef, useState, useEffect } from "react";
import get from "lodash/get";
import throttle from "lodash/throttle";
import { Link } from "@quintype/components";
import { useDispatch, useSelector } from "react-redux";

import { OPEN_SEARCHBAR } from "../../../store/actions";
import { MenuItem } from "../../menu-item";
import Logo from "../../../atoms/icons/logo";
import HamburgerNotification from "../../../molecules/hamburger-notification";
import SocialShareIcons from "../../../molecules/social-share-header";
import LatestButton from "../../../atoms/latest-button";
import EPaperButton from "../../../atoms/e-paper-button";
import MenuRight from "../../../atoms/icons/menu-right";
import HamburgerMenus from "../hamburger-menus";

import "./desktop-header.m.css";
import SearchBox from "../../../atoms/search-box";
import JoinDHChannel from "../../../atoms/join-dh-channel";

const DesktopHeader = () => {
  const getState = useSelector((state) => state);
  const dispatch = useDispatch();

  const primaryMenus = get(getState, ["qt", "data", "navigationMenu", "primaryMenus"], []);
  const secondaryMenus = get(getState, ["qt", "data", "navigationMenu", "secondaryMenus"], []);

  const navRef = useRef();
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = throttle(() => {
    if (typeof window !== "undefined") {
      if (window.scrollY > 105) setIsSticky(true);
      if (window.scrollY < 106) setIsSticky(false);
    }
  }, 250);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const renderMenuItems = (items, type = "primary") => (
    <div styleName={`menu-wrapper ${type}-menu-wrapper`}>
      {items.slice(0, type === "primary" ? 10 : 9).map((item, index) => (
        <div key={index} styleName={`${type}-menu-item`}>
          {type === "secondary" && <MenuRight />}
          <MenuItem
            type={type}
            changeTextColor={type === "primary" && index === 2}
            item={item}
            menuStyle="menu-link"
            toggleHandler={() => {
              dispatch({ type: OPEN_SEARCHBAR, isSearchBarOpen: false });
            }}
          />
          {item.children.length > 0 && (
            <>
              <div styleName="triangle"></div>
              <div styleName="ddsection">
                {Array.from({ length: Math.min(item.children.length, 32) }, (subitem, idx) => (
                  <div key={idx} styleName="subitem">
                    <Link externalLink={subitem.isExternalLink} href={subitem && subitem?.url}>
                      {subitem.title}
                    </Link>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <>
      <div styleName="header">
        <div ref={navRef} styleName="primary">
          <div className="container" styleName="primary-wrapper">
            <div styleName="logo-wrapper">
              <Link href="/">
                <Logo width="76.67px" height="70px" />
              </Link>
              <div style={{ display: isSticky ? "flex" : "none" }}>
                <HamburgerNotification />
              </div>
            </div>
            {renderMenuItems(primaryMenus)}
            <div style={{ display: isSticky ? "block" : "none" }}>
              <SearchBox />
            </div>
            <div styleName="share-icons-wrapper" style={{ display: isSticky ? "none" : "flex" }}>
              <SocialShareIcons />
            </div>
          </div>
        </div>

        <div styleName="secondary" style={{ display: !isSticky ? "block" : "none" }}>
          <div className="container" styleName="secondary-wrapper">
            <div>
              <HamburgerNotification />
            </div>
            {renderMenuItems(secondaryMenus, "secondary")}
            <div styleName="button-wrapper">
              {/* <LatestButton /> */}
              <JoinDHChannel />
              <EPaperButton />
              <SearchBox />
            </div>
          </div>
        </div>
      </div>
      <HamburgerMenus />
    </>
  );
};

export default DesktopHeader;
